import './style.scss'
import Layer from '../../../../Shared/Layer'
import { Col, Container, Row } from '@trendmicro/react-grid-system'
import Button from '../../../../Shared/Form/Button'
import { useTranslation } from 'react-i18next'
import { BUTTON_MIN_WIDTH } from '../../../../Shared/Form/Button/constants'

const UnsavedChangesNoticeOverlay = ({ onCancel, onConfirm }) => {
  const { t } = useTranslation()
  return (
    <Layer
      type="center"
      size="small"
      id={'unsaved-changes'}
      show={true}
      onHideClick={onCancel}
      background="light-grey"
      borderRadius="20px"
      showCloseIcon={false}
      className="unsaved-changes-notice-overlay"
      closeOnEsc={true}
    >
      <Container fluid>
        <Row style={{ alignItems: 'center' }}>
          <Col xs={3}>
            <span className="unsaved-changes-notice-overlay__gear_icon"></span>
          </Col>
          <Col xs={9}>
            <span className="unsaved-changes-notice-overlay__header">{t('UNSAVED_CHANGES_NOTICE_HEADER')}</span>
            <br/>
            <br/>
            <span className="unsaved-changes-notice-overlay__subheader">
              {t('UNSAVED_CHANGES_NOTICE_MESSAGE')}
            </span>
          </Col>
        </Row>
        <Row>
          <br/>
        </Row>
        <Row style={{ textAlign: 'center' }}>
          <Col>
            <Button style={{ marginRight: 20 }} onClick={onConfirm}
                    classNames="Button-Outline-Dark-Blue" minWidth={BUTTON_MIN_WIDTH}>{t('BUTTON_LEAVE')}</Button>
            <Button onClick={onCancel}
                    classNames="Button-Primary" minWidth={BUTTON_MIN_WIDTH}>{t('BUTTON_CANCEL')}</Button>
          </Col>
        </Row>
      </Container>
    </Layer>
  )
}

export default UnsavedChangesNoticeOverlay
